import React, { useContext } from 'react';
import Button from '@atlaskit/button';
import { DebouncedTextfield } from '../../common/DebouncedTextfield';
import { GlobalContext } from '../../common/GlobalContext';
import ChevronUpIcon from '@atlaskit/icon/glyph/chevron-up';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import { OptionSearchData, OptionSearchDataChange } from './search/custom-field-options-search-logic';
import { SearchBoxContainer, SearchBoxControlsContainer, SearchBoxFieldContainer } from '../layout/SearchBoxContainers';
import { token } from '@atlaskit/tokens';

export const FieldEditorSearchBar = ({
  isDisabled,
  searchData,
  onSearchInputChanged,
}: {
  isDisabled: boolean;
  searchData: OptionSearchData;
  onSearchInputChanged: (change: OptionSearchDataChange) => void;
}) => {
  const { t } = useContext(GlobalContext);

  return (
    <SearchBoxContainer>
      <SearchBoxControlsContainer>
        {searchData.searchKey !== '' && (
          <div data-testid="ce-options-search-found" style={{ textAlign: 'right' }}>
            {searchData.currentOfMaxFound}/{searchData.maxFound}
          </div>
        )}
        {searchData.searchKey !== '' && (
          <>
            <div style={{ margin: '0 5px 0 10px', width: '36px' }}>
              <span data-e2e-search-next-button="true">
                <Button
                  isDisabled={isDisabled || !searchData.hasPrevious}
                  appearance="subtle"
                  testId="ce-options-search-previous"
                  onClick={() => onSearchInputChanged({ direction: 'PREVIOUS' })}
                  iconBefore={
                    <ChevronUpIcon
                      size="medium"
                      label="previous"
                      primaryColor={isDisabled || !searchData.hasPrevious ? token('color.text.disabled', '#ccc') : token('color.text.accent.blue.bolder', '#253858')}
                    />
                  }
                />
              </span>
            </div>
            <div style={{ margin: '0 10px 0 0', width: '36px' }}>
              <span data-e2e-search-next-button="true">
                <Button
                  isDisabled={isDisabled || !searchData.hasNext}
                  appearance="subtle"
                  testId="ce-options-search-next"
                  onClick={() => onSearchInputChanged({ direction: 'NEXT' })}
                  iconBefore={
                    <ChevronDownIcon
                      size="medium"
                      label="next"
                      primaryColor={isDisabled || !searchData.hasNext ? token('color.text.disabled', '#ccc') : token('color.text.accent.blue.bolder', '#253858')}
                    />
                  }
                />
              </span>
            </div>
          </>
        )}
      </SearchBoxControlsContainer>
      <SearchBoxFieldContainer>
        <DebouncedTextfield
          testId="ce-options-search-input"
          isDisabled={isDisabled}
          onFilterChanged={(key) => onSearchInputChanged({ searchKey: key, direction: 'UNCHANGED' })}
          value={'' /*searchData.searchKey*/}
          placeholder={t('global.searchFieldPlaceholder')}
        />
      </SearchBoxFieldContainer>
    </SearchBoxContainer>
  );
};
